import RadioCardListPage from "@components/RadioCardListPage"
import {
  getIsFemaleFromLocalStorage,
  isHomeDesignFlow,
} from "@helpers/localStorage"

const HOME_OPTIONS = [
  { emoji: "😍", key: "stunning" },
  { emoji: "🤗", key: "soCozy" },
  { emoji: "😮", key: "soOrganized" },
  { emoji: "🌟", key: "uniqueStyle" },
  { emoji: "✨", key: "feelsLikeYou" },
  { emoji: "🧘", key: "soCalm" },
]

export default function ComplimentPage() {
  if (isHomeDesignFlow()) {
    return (
      <RadioCardListPage
        translationKey="complimentHomeDesign"
        options={HOME_OPTIONS}
      />
    )
  }

  const isFemale = getIsFemaleFromLocalStorage()
  const OPTIONS = [
    { emoji: "😍", key: "stunning" },
    { emoji: "💪", key: "confident" },
    { emoji: "🌟", key: "unique" },
    { emoji: isFemale ? "👩‍💼" : "👨‍💼", key: "professional" },
    { emoji: "✨", key: "you" },
    { emoji: "🌺", key: "younger" },
  ]

  return <RadioCardListPage translationKey="compliment" options={OPTIONS} />
}
